import { render } from "./DeviceList.vue?vue&type=template&id=5923a503&ts=true"
import script from "./DeviceList.vue?vue&type=script&lang=ts"
export * from "./DeviceList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__